import styled from '@emotion/styled'

const Image = styled.img({
  maxWidth: '100%',
})

export default Image
